<template>
    <div class="Office" 
        @click="$store.dispatch('switchCity', index)"
        :class="$store.state.showCity == index ? 'officeSelected' : 'test'"
        :id="anim">
        <img id="test" :src="getImgUrl(img)" :alt="alt" class="officeImg">
        <div class="officeTxt">
            <p class="officeCity">{{city}}</p>
            <p v-html="adresse"></p>
        </div>
    </div>
</template>

<script>
export default {
    name:'Office',
    props: {
        alt: String,
        img: String,
        city: String,
        adresse: String,
        anim: String,
        index: Number
    },
    methods: {
        getImgUrl: function(img) {
            return require('@/assets/imagesHome/'+img)
        }
    },
    computed: {
      
    },
    mounted() {
        const animOffice0 = this.$scrollmagic.scene({
          triggerElement: '#triggerOffice0',
          duration: 500
        })
        .setTween( "#animOffice0", 0.5, {opacity:1})

        const animOffice1 = this.$scrollmagic.scene({
          triggerElement: '#triggerOffice1',
          duration: 500
        })
        .setTween( "#animOffice1", 0.5, {opacity:1})
        
        const animOffice2 = this.$scrollmagic.scene({
          triggerElement: '#triggerOffice2',
          duration: 500
        })
        .setTween( "#animOffice2", 0.5, {opacity:1})       

        this.$scrollmagic.addScene([animOffice0, animOffice1, animOffice2])
    }
    
}
</script>

<style scoped lang="scss">
@import '@/assets/style/offices.scss';
</style>